import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Diamond, ShieldX } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const denied = location.state?.denied;

  useEffect(() => {
    if (!loading && user) navigate("/");
  }, [loading, user, navigate]);

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  const login = () => {
    const redirectUrl = window.location.origin + "/";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-[#FDFDFC] flex items-center justify-center px-6" data-testid="login-page">
      <div className="w-full max-w-sm text-center">
        <span className="mx-auto w-14 h-14 rounded-full bg-slate-900 flex items-center justify-center mb-6">
          <Diamond size={24} className="text-[#D4AF37]" />
        </span>
        <h1 className="font-display text-3xl font-semibold tracking-tight text-slate-900">
          OPM Group <span className="text-slate-400 italic font-normal">/ MIS</span>
        </h1>
        <p className="text-sm text-slate-500 mt-2 mb-8">Restricted access. Sign in to continue.</p>
        {denied && (
          <div
            data-testid="access-denied-msg"
            className="flex items-start gap-2 text-left bg-red-50 border border-red-200 text-red-700 text-xs font-semibold px-4 py-3 rounded-lg mb-6"
          >
            <ShieldX size={15} className="shrink-0 mt-0.5" />
            This Google account is not authorised. Ask the admin to whitelist your email, then sign in again.
          </div>
        )}
        <button
          onClick={login}
          data-testid="google-login-btn"
          className="w-full inline-flex items-center justify-center gap-3 rounded-full bg-slate-900 text-white text-sm font-semibold px-7 py-3.5 hover:bg-[#B08D26] transition-colors"
        >
          <svg width="18" height="18" viewBox="0 0 24 24">
            <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.27-4.74 3.27-8.1z" />
            <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" />
            <path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.06H2.18A10.97 10.97 0 0 0 1 12c0 1.77.43 3.45 1.18 4.94l3.66-2.84z" />
            <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.06l3.66 2.84c.87-2.6 3.3-4.52 6.16-4.52z" />
          </svg>
          Sign in with Google
        </button>
        <p className="text-[11px] text-slate-400 mt-6">Only whitelisted email IDs can access this dashboard.</p>
      </div>
    </div>
  );
}
